<template>
    <main class="main dashboard pt-lg-4 pt-3">
        <div class="container">
            <ui-slider
                v-if="topBanner"
                class="dashboard__banner"
                :content="topBanner"
            />

            <section class="mt-4 dashboard__sections" data-walk="1-1">
                <section class="dashboard__general mb-md-0 mb-3">
                    <div class="row row-cols-1 row-cols-lg-2">
                        <div
                            class="col flex-column d-sm-flex col-widget announcements-widget"
                        >
                            <page-preloader
                                mode="wrapper"
                                :isLoading="dashboardStatus === 'loading'"
                            >
                                <div
                                    class="dashboard-widget dashboard-widget--newsletters"
                                >
                                    <div
                                        class="d-flex align-items-center gap-1 justify-content-between"
                                    >
                                        <div
                                            class="d-flex gap-0-5 align-items-center"
                                        >
                                            <h4
                                                class="dashboard-widget__title mb-0"
                                                v-text="'Ogłoszenia'"
                                            />
                                            <span
                                                class="a-counter"
                                                v-if="announcementsTotal"
                                                v-tooltip="
                                                    $store.getters
                                                        .getAnnouncementsTotalTooltip
                                                "
                                                @click="goToNewAnnouncements"
                                            >{{ announcementsTotal }}</span>
                                        </div>
                                        <the-btn
                                            class="btn-sm"
                                            @click.native="
                                                $router.push({
                                                    name: 'announcements'
                                                })
                                            "
                                        >Więcej ogłoszeń</the-btn>
                                    </div>
                                    <div class="dashboard-widget__content">
                                        <div
                                            class="d-flex flex-column gap-0-5 mt-3"
                                        >
                                            <template
                                                v-if="
                                                    announcements &&
                                                        announcements.length
                                                "
                                            >
                                                <announcement-preview
                                                    v-for="announcement in announcements"
                                                    size="small"
                                                    show-more-button
                                                    show-new-badge
                                                    :announcement="announcement"
                                                    :key="announcement.id"
                                                />
                                            </template>
                                            <p class="mt-2 mb-0" v-else>
                                                Brak aktualnych ogłoszeń
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </page-preloader>
                        </div>
                        <div
                            class="col mt-4 mt-lg-0 d-flex flex-column"
                            v-if="dashboardSnippets"
                        >
                            <dashboard-slider :data="dashboardSnippets" />
                        </div>
                    </div>
                </section>

                <m-kasa-widget
                    v-if="$store.getters.mKasaService"
                    class="dashboard__mKasaWidget mt-4 mb-lg-0 mb-4"
                />

                <section class="dashboard__charts" v-if="!isShopUser">
                    <div class="mt-4 mb-4 row row-cols-1 row-cols-lg-2">
                        <div class="col">
                            <dashboard-chart
                                v-if="receiptCount"
                                :chartOptions="receiptCount"
                                :customHeaderTitle="
                                    'Liczba paragonów wystawionych w ostatnich 7 dniach'
                                "
                                :customHeaderSubtitle="
                                    this.$brand.dashboard.statisticsDesc
                                "
                                :isCustomHeader="true"
                            >
                            </dashboard-chart>
                        </div>
                        <div class="col mt-4 mt-lg-0">
                            <dashboard-chart
                                v-if="receiptAmount"
                                :chartOptions="receiptAmount"
                                :customHeaderTitle="
                                    'Wartość sprzedaży (zł) w ostatnich 7 dniach'
                                "
                                :customHeaderSubtitle="
                                    this.$brand.dashboard.statisticsDesc
                                "
                                :isCustomHeader="true"
                            >
                            </dashboard-chart>
                        </div>
                    </div>
                </section>
                <section class="dashboard__summary mb-md-5 mb-2 mt-md-3 mt-0">
                    <div
                        class="
                            card-container
                            row row-cols-1 row-cols-sm-2 row-cols-lg-4
                        "
                    >
                        <div
                            v-for="(card, idx) in cards"
                            :key="idx"
                            class="
                                col col-md-6 col-xl-3
                                mb-3 mb-lg-0
                                mt-1 mt-lg-0
                            "
                        >
                            <dashboard-card :data="card" />
                        </div>
                    </div>
                </section>
            </section>
        </div>
    </main>
</template>

<script>
import DashboardChart from '@/components/dashboard/DashboardChart'
import DashboardCard from '@/components/dashboard/DashboardCard'
import DashboardSlider from '@/components/dashboard/DashboardSlider'
import MKasaWidget from '@/components/reports/MKasaWidget'
import AnnouncementPreview from '@/components/announcements/AnnouncementPreview'

export default {
    created() {
        this.fetch()
    },
    components: {
        DashboardChart,
        DashboardCard,
        DashboardSlider,
        MKasaWidget,
        AnnouncementPreview
    },
    computed: {
        dashboardStatus() {
            return this.$store.getters.getDashboardStatus
        },
        receiptAmount() {
            return this.$store.getters.getReceiptAmount
        },
        receiptCount() {
            return this.$store.getters.getReceiptCount
        },
        companies() {
            return this.$store.getters.getCompaniesChart
        },
        cards() {
            return this.$store.getters.getDashboardCards
        },
        dashboardSnippets() {
            return this.$store.getters.getDashboardSnippets
        },
        isShopUser() {
            return this.$store.getters.isShopUser
        },
        topBanner() {
            return this.$store.getters.getDashboardTopBanner
        },
        announcements() {
            return this.$store.getters.getAnnouncements
        },
        announcementsTotal() {
            return this.$store.getters.getAnnouncementsTotal
        }
    },
    methods: {
        async fetch() {
            this.$store.dispatch('receiptCountFetch')
            this.$store.dispatch('dashboardStatsFetch')
            this.$store.dispatch('devicesFetch')

            this.$store.dispatch('snippetsLoad', {
                code: 'snippet001',
                moduleName: 'advertisements'
            })

            this.$store.dispatch('snippetsLoad', {
                code: 'snippet005',
                moduleName: 'advertisements'
            })
            await this.$store.dispatch('clearFilters', 'announcements')
            await this.$store.dispatch('loadAnnouncements', {
                limit: 3,
                offset: 0,
                archival: false,
                sort: {
                    by: 'PUBLICATION_DATE',
                    direction: 'desc'
                }
            })

            this.$store.dispatch('snippetsLoad', {
                code: 'pwa.dashboard.proposed_service',
                moduleName: 'dashboard'
            })
            this.$store.dispatch('fetchAnnouncementsTotal')
        },
        async goToNewAnnouncements() {
            await this.$store.dispatch('clearFilters', 'announcements')
            await this.$store.dispatch('setFilter', {
                filter: 'read',
                value: true,
                moduleName: 'announcements'
            })
            this.$router.push({ name: 'announcements' })
        }
    }
}
</script>
